import { render, staticRenderFns } from "./AuthorRole.vue?vue&type=template&id=47668adf&scoped=true&"
import script from "./AuthorRole.vue?vue&type=script&lang=js&"
export * from "./AuthorRole.vue?vue&type=script&lang=js&"
import style0 from "./AuthorRole.vue?vue&type=style&index=0&id=47668adf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47668adf",
  null
  
)

export default component.exports